import { render } from "./FDS.vue?vue&type=template&id=8eec708e&scoped=true"
import script from "./FDS.vue?vue&type=script&lang=js"
export * from "./FDS.vue?vue&type=script&lang=js"

import "./FDS.vue?vue&type=style&index=0&id=8eec708e&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eec708e"]])

export default __exports__